var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"spir-history"},[_c('table',[_vm._m(0),_c('tbody',_vm._l((_vm.histories),function(history){return _c('tr',{key:history.no},[_c('td',[_vm._v(_vm._s(history.no))]),_c('td',[_c('router-link',{attrs:{"to":{
            name: 'StudentCourseGrades',
            params: {
              studentId: _vm.studentId,
              courseHistoryId: history.fromCourseHistoryId }
          }}},[_vm._v(" "+_vm._s(history.fromCourseName)+" ")]),_vm._v(" → "),_c('router-link',{attrs:{"to":{
            name: 'StudentCourseGrades',
            params: {
              studentId: _vm.studentId,
              courseHistoryId: history.toCourseHistoryId }
          }}},[_vm._v(" "+_vm._s(history.toCourseName)+" ")])],1),_c('td',[_c('router-link',{attrs:{"to":{
            name: 'ApplicationDetail',
            params: { applicationId: history.applicationId }
          }}},[_vm._v(" SPIR問い合わせ ")])],1)])}),0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_c('th',[_vm._v("Course")]),_c('th',[_vm._v("detail")])])])
}]

export { render, staticRenderFns }